import axios from 'axios';
import { FORNECEDORES_API_URL } from 'src/constants/urls';

export const api = axios.create({
  baseURL: FORNECEDORES_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const tokenRegister = token => {
  const interceptorId = api.interceptors.request.use(config => {
    if (!config.headers.token) {
      Object.assign(config.headers, { Authorization: token });
    }

    return config;
  });

  return () => api.interceptors.request.eject(interceptorId);
};
